<ng-container *ngIf="outlet === 'primary'; else outside">
    <div class="container">
        <cmn-header>
            <ng-content left select="[header-left]"></ng-content>
            <ng-content right select="[header-right]"></ng-content>
        </cmn-header>
        <div class="content">
            <router-outlet name="primary"></router-outlet>
        </div>

        <ng-content select="[footer]"></ng-content>
    </div>
</ng-container>
<ng-template #outside>
    <ns-out-layout>
        <router-outlet name="out"></router-outlet>
    </ns-out-layout>

    <ng-content select="[login-footer]"></ng-content>
</ng-template>

<div class="mask" [ngClass]="{'inside': outlet === 'primary'}" [@inOut]="loadingService.isLoading$ | async">
    <cmn-loader select="[loader]"></cmn-loader>
</div>
<div kendoDialogContainer></div>
